import { memo } from 'react';
import { Title } from 'src/components';
import styles from './styles.module.scss';
import classNames from 'classnames';
interface IProps {
    description: string;
}
export function ContentSapo({ description }: IProps) {
    if (!description) {
        return null;
    }

    return (
        <Title className={classNames(styles.sapo)} renderAs="h2">
            {description}
        </Title>
    );
}

export default memo(ContentSapo);
